import { Buffer } from 'buffer';

export const decodeBase64 = (encodedText: string) => {
	try {
		const decodedText = Buffer.from(encodedText, 'base64').toString('utf-8');
		console.log('dec', decodedText);
		return decodedText;
	} catch (error) {
		console.log('Here', error);
		return null;
	}
};

export const getCapitalCase = (text: string | null | undefined) => {
	try {
		text = text
			?.toLowerCase()
			.split(' ')
			.map((word) => word[0].toUpperCase() + word.slice(1))
			.join(' ');
	} catch (error) {
		/* empty */
	}
	return text;
};

export const addPeriod = (text: string | null | undefined) => {
	try {
		if (!text || !text.trim() || text.trim().endsWith('.')) return text;
		return text.trim() + '.';
	} catch (error) {
		/* empty */
	}
	return text;
};

export const getCapitalCaseAll = (text: string | null | undefined) => {
	try {
		text = text?.toUpperCase();
	} catch (error) {
		/* empty */
	}
	return text;
};

export const getNumberOfNightsBetweenDates = (
	arrivalDate: Date,
	departureDate: Date
) => {
	if (!arrivalDate || !departureDate) {
		return undefined;
	}
	const diff = departureDate.getTime() - arrivalDate.getTime();
	return Math.ceil(diff / (1000 * 3600 * 24));
};
